export enum WAConversationHandler {
  /** The AI agent replies to this conversation automatically */
  AI = "AI",
  /** A human owns this conversation, the agent stays quiet */
  HUMAN = "HUMAN",
}
